import React from 'react';

//Component
import { Login } from '../../components/auth';

export const LoginPage = () => {
  return (
    <>
      <Login />
    </>
  );
};
